import React, { useState } from 'react';

import '../../../static/css/main.css'
import '../../../static/css/animate.css'
import '../../../static/fonts/stylesheet.css'
import { useDispatch, useSelector } from 'react-redux';
import { selectIdBank, selectIndexLifeMin, selectIndexPropertyMin, selectListCompaniesLife, selectListCompaniesProperty, selectTypeObject, setIdBank, setIndexLifeMin, setIndexPropertyMin } from '../../calc/calcSlice';


import rifizen from "../../../static/img/rifizen.png"

import icon_home_gray from "../../../static/img/icon-home-gray.svg"
import icon_heart_gray from "../../../static/img/icon-heart-gray.svg"


import heart from "../../../static/img/heart.svg"

import icon_s3_1 from "../../../static/img/icon-s3-1.svg"
import icon_s3_2 from "../../../static/img/icon-s3-2.svg"
import arrow_dropdown_gray from "../../../static/img/Arrow_dropdown-gray.svg"

import absolut_logo from '../../../static/logo/absolut-logo.png'
import zetta_logo from '../../../static/logo/zetta-logo.png'
import pari_logo from '../../../static/logo/pari-logo.png'
import vsk_logo from '../../../static/logo/vsk-logo.png'
import { selectLifeOption, selectPropertyOption, setLifeOption, setPropertyOption } from '../precalcSlice';
import { setCalcPage } from '../../home/homeSlice';
import { digitNumber } from '../../funcs/funcs';


export function OfferCard(props) {
    const dispatch = useDispatch()

    const idBank = useSelector(selectIdBank)

    const [showDropDown, setShowDropDown] = useState(false);

    const list_companies_property = useSelector(selectListCompaniesProperty)
    const index_property_min = useSelector(selectIndexPropertyMin)
    const list_companies_life = useSelector(selectListCompaniesLife)
    const index_life_min = useSelector(selectIndexLifeMin)

    const lifeOption = useSelector(selectLifeOption)
    const propertyOption = useSelector(selectPropertyOption)

    const [showResPreCalc, setShowResPreCalc] = useState(false);
    const [showListCompanyProperty, setShowListCompanyProperty] = useState(false);
    const [showListCompanyLife, setShowListCompanyLife] = useState(false);
    const [showDataPolice, setShowDataPolice] = useState(false);
    const [showAnotherOffers, setShowAnotherOffers] = useState(false);

    const handleClickDropDown = () => {
        setShowDropDown(!showDropDown)
    }

    function handleClickBank(value) {
        dispatch(setIdBank(value))
        setShowDropDown(false)
    }

    const handleClickCompanyProperty = () => {
        setShowListCompanyProperty(!showListCompanyProperty)
    }

    const handleClickCompanyLife = () => {
        setShowListCompanyLife(!showListCompanyLife)
    }

    const handleClickDataPolice = () => {
        setShowDataPolice(!showDataPolice)
    }

    const handleClickLifeOption = () => {
        dispatch(setLifeOption(!lifeOption))
    }

    const handleClickPropertyOption = () => {
        dispatch(setPropertyOption(!propertyOption))
    }

    const handleClickRegPolice = () => {
        dispatch(setCalcPage('calc'))
    }


    function handleSelectCompanyProperty(index) {
        dispatch(setIndexPropertyMin(index))
        dispatch(setPropertyOption(true))
        setShowListCompanyProperty(false)
    }

    function handleSelectCompanyLife(index) {
        dispatch(setIndexLifeMin(index))
        dispatch(setLifeOption(true))
        setShowListCompanyLife(false)
    }

    return (
        <div class="tab-body-blok-info-401" id="tab-body-blok-info-401-112" style={props.company_property ? { }: { display: 'none' }}>
            <p class="banner-text banner-text-2">{props.type}</p>
            <div class="tab-body-blok-info-401-element">
                <div class="form-1-col form-1-col-1 form-1-col-1111">
                    <div class="form-group">
                        <div class="dropdown dropdown-111">
                            <img class="img-1" src={icon_s3_1} alt="" />

                            <button onClick={handleClickCompanyProperty} class="dropdown__button dropdown__button-111">
                                {propertyOption ? props.company_property : 'Добавить страхование имущества'}
                            </button>
                            {showListCompanyProperty &&
                                <ul class="dropdown__list dropdown__list-111">
                                    {
                                        list_companies_property.map((company, index) => {
                                            return (
                                                <li
                                                    onClick={() => handleSelectCompanyProperty(index)}
                                                    key={index}
                                                    class="drop-img-1 dropdown__list-item dropdown__list-item-111 dropdown__list-item-2"
                                                >
                                                    <img class="bank-image bank-image-2" src={company.logo}
                                                        alt="banks"
                                                    />
                                                    {company.company}
                                                    <span>{company.premium}</span>
                                                </li>
                                            )
                                        })
                                    }

                                </ul>
                            }
                            <input type="text" name="select-category" value=""
                                class="dropdown__input-hidden" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-body-blok-info-401-element tab-body-blok-info-401-element-2"
                id="tab-body-blok-info-401-element-2-222">
                <div class="form-1-col form-1-col-1 form-1-col-1111">
                    <div class="form-group">
                        <div class="dropdown dropdown-111">
                            <img class="img-5" src={heart} alt="" />
                            <button onClick={handleClickCompanyLife} class="dropdown__button dropdown__button-111">
                                {lifeOption ? props.company_life : 'Добавить страхование жизни'}
                            </button>
                            {showListCompanyLife &&
                                <ul class="dropdown__list dropdown__list-111">
                                    {
                                        list_companies_property.map((company, index) => {
                                            return (
                                                <li onClick={() => handleSelectCompanyLife(index)} key={index} class="drop-img-6 dropdown__list-item dropdown__list-item-111 dropdown__list-item-2"
                                                    data-value="СБЕР Страхование">
                                                    <img class="bank-image bank-image-2" src={company.logo}
                                                        alt="banks"
                                                    />
                                                    {company.company}
                                                    <span>{company.premium}</span>
                                                </li>
                                            )
                                        })
                                    }

                                </ul>
                            }
                            <input type="text" name="select-category" value=""
                                class="dropdown__input-hidden" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-body-4-blok-price">
                <div class="tab-body-4-price-1">
                    {digitNumber(Math.round(100 * (((propertyOption && props.premium_property) + (lifeOption && props.premium_life)) / (100 - 10))).toString())}
                </div>
                <div class="tab-body-4-price-2">
                    -10%
                </div>
                <div class="tab-body-4-price-3">
                    {digitNumber(Math.round(((propertyOption && props.premium_property) + (lifeOption && props.premium_life))).toString()) + ' ₽'}
                </div>
            </div>
            <div class="tab-body-4-dopinfo-blok-link">
                <p class="tab-body-4-dopinfo-link" id="tab-body-4-dopinfo-link-2"
                    onClick={handleClickDataPolice}
                >
                    Данные полиса
                    <img class="icon-down-arrow icon-down-arrow-401"
                        src={arrow_dropdown_gray} alt="arrow icon" />
                </p>
            </div>
            {showDataPolice &&
                <div class="tab-body-4-blok-dopinfo tab-body-4-blok-dopinfo-1"
                    id="tab-body-4-blok-dopinfo-2">
                    <div class="tab-body-4-blok-dopinfo-col">
                        <img class="icon-home-gray" src={icon_home_gray} alt="home" />
                        <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-1">
                            Страхование конструктивных
                            элементов недвижимости (крыша,
                            окна, лестницы, стены, перекрытия, перегородки).<br />
                            Риски в соответствии с требованием банка.<br />
                            Пожар, взрыв, нанесение вреда в результате стихийных бедствий,
                            постороннее воздействие (падение деревьев и прочее).</p>
                    </div>
                    <div class="tab-body-4-blok-dopinfo-col">
                        <img class="icon-home-gray" src={icon_heart_gray} alt="home" />
                        <p class="tab-body-4-blok-dopinfo-text tab-body-4-blok-dopinfo-text-2">
                            Страхование от несчастных
                            случаев и болезней.<br />
                            Риски в соответствии с требованием банка.<br />
                            Установление инвалидности 1–2 группы в результате несчастного случая
                            или болезни.<br />
                            Смерть в результате несчастного случая или болезни.</p>
                    </div>
                </div>
            }
            <div onClick={handleClickRegPolice} class="button button-1 button-novostroiki-1 button-step-4001">
                Оформить онлайн
            </div>
        </div>
    );
}



